import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./home.css";
import ProfilePhoto from "assets/images/profile.png";
import Header from "components/Header";
import Footer from "components/Footer";
import ParticleBackground from "components/ParticleBackground";

const Home = () => {
  const { t } = useTranslation();
  const [displayText, setDisplayText] = useState("");
  const fullText = "console.log('Hello, World! 👋');";

  useEffect(() => {
    let i = 0;
    const timer = setInterval(() => {
      if (i < fullText.length) {
        setDisplayText(fullText.slice(0, i + 1));
        i++;
      } else {
        clearInterval(timer);
      }
    }, 100);

    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      <ParticleBackground />
      <Header />
      <div className="home-profile fade-in">
        <div className="home-profile-container">
          <div className="home-profile-top">
            <div className="home-profile-avatar slide-in-left">
              <img src={ProfilePhoto} alt="Vincent Shi" />
            </div>
            <div className="home-profile-content slide-in-right">
              <h1>Vincent Shi</h1>
              <h2>{t("home.role")}</h2>
              <p>{t("home.intro")}</p>

              <div className="terminal">
                <div className="terminal-prompt">
                  <span className="typing-effect">{displayText}</span>
                </div>
              </div>

              <div className="home-profile-stats">
                <div className="stat-item">
                  <div className="stat-number">4+</div>
                  <div className="stat-label">{t("home.yearsExperience")}</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">10+</div>
                  <div className="stat-label">{t("home.techStack")}</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">2</div>
                  <div className="stat-label">{t("home.majorCompanies")}</div>
                </div>
              </div>
            </div>
          </div>

<div className="code-block">
            <pre
              dangerouslySetInnerHTML={{
                __html: `<span class="code-comment">// Vincent's Code Space</span>
<span class="code-keyword">fn</span> <span class="code-function">main</span>() {
    <span class="code-keyword">let</span> developer = <span class="code-type">Developer</span> {
        <span class="code-property">name</span>: <span class="code-string">"Vincent Shi"</span>,
        <span class="code-property">role</span>: <span class="code-string">"Software & DevOps Engineer"</span>,
        <span class="code-property">motto</span>: <span class="code-string">"Code, Creativity, and Life: Weaving Passion into Every Line"</span>,
        <span class="code-property">location</span>: <span class="code-string">"Sydney 🇦🇺"</span>,
    };

    <span class="code-function">println!</span>(<span class="code-string">"Building scalable systems, one commit at a time."</span>);
}`,
              }}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
